import { SVGProps, Ref, forwardRef } from 'react';

export const BanFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M2.013 3.003C.934 4.39.5 6.195.5 8c0 3.75 1.875 7.5 7.5 7.5 2.208 0 3.838-.578 5.004-1.506z"
                    fill="currentColor"
                />
                <path
                    d="m2.996 2.007 10.991 10.99C15.066 11.612 15.5 9.806 15.5 8 15.5 4.25 13.625.5 8 .5c-2.208 0-3.838.578-5.004 1.507"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
BanFilledSize16Glyph.displayName = 'BanFilledSize16Glyph';
